export default "__VITE_ASSET__CBBeBNBR__"